// `&nbsp;` plus explicit line-height/font-size keep some clients (Outlook,
// Gmail) from collapsing the cell to zero height. Per spec/design-system.md
// §Primitive 9.

import { html } from '../render'
import { HtmlString } from '../types'

export interface SpacerProps {
  height: number
}

export function spacer({ height }: SpacerProps): HtmlString {
  // prettier-ignore
  return html`<tr><td height="${height}" style="height: ${height}px; line-height: ${height}px; font-size: ${height}px;">&nbsp;</td></tr>`
}
